<template>
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div>
                    <p class="bold dp-inblock h-30px font-23 mb-20 w-300px">카드사 명 입력</p>
                    <a class="float-right layer-close ml-30 pointer" @click="$emit('close')">
                        <img src="../../assets/img/close.png" alt="close" class="close-btn">
                    </a>
                    <div>
                        <span class="font-13 bold">빠른 결제 취소를 위해 결제하셨던 카드사 명을 선택해 주세요.</span>
                    </div>
                    <div class="mt-20 mb-20">
                        카드사명
                        <select v-model="cardName" style=" margin-left: 30px;height: 35px;width: 30%;font-size: 15px;">
                            <option value="">카드사 선택</option>
                            <option value="KB국민">KB국민</option>
                            <option value="롯데">롯데</option>
                            <option value="현대">현대</option>
                            <option value="BC">BC</option>
                            <option value="외한">외한</option>
                            <option value="삼성">삼성</option>
                            <option value="신한">신한</option>
                            <option value="하나">하나</option>
                            <option value="NH농협">NH농협</option>
                            <option value="씨티">씨티</option>
                            <option value="우리">우리</option>
                            <option value="기타">기타</option>
                        </select>
                        <input type="text" v-if="cardName === '기타'" style="width: 40%;height: 35px;margin-left: 10px;" v-model="etcName" />
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="btn ml-05 pointer" @click="cancel()">확인</a>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: ['parentIdx', 'parentCancelData'],

    data: () => ({
        text: '',
        cardName: '',
        etcName: '',
        subjectIdx: '',
        studentSubjectIdx: '',
        cancelData: {}
    }),

    mounted() {
        this.studentSubjectIdx = this.parentIdx
        this.cancelData = this.parentCancelData
        // console.log('this.subjectIdx', this.subjectIdx)
        // console.log('this.cancelData', this.cancelData)
    },

    methods: {
        cancel() {
            var studentSubjectIdx = this.studentSubjectIdx
            var params = {
                cardName: this.cardName,
                studentSubjectIdx: studentSubjectIdx,
            }

            var params = new URLSearchParams()

            params.append('cardName', this.cardName)
            params.append('studentSubjectIdx', studentSubjectIdx)

            if (this.cardName === '') {
                alert('카드사를 선택해주세요.')
                return false
            }

            if (this.cardName === '기타') {
                if (this.etcName.trim() === '') {
                    alert('카드사명을 입력해주세요.')
                    return false
                } else {
                    params.delete('cardName')
                    params.append('cardName', this.etcName)
                }
            }

            // console.log('params', params)

            var con_test = confirm("해당 수강신청을 정말 취소하시겠습니까?");
            if (con_test == true) {
                this.axios.post(this.axios.root + this.axios.port + `/user/cancle-apply/${studentSubjectIdx}`, params)
                    .then(res => {
                        // console.log('res', res)
                        alert('수강신청이 취소되었습니다')
                        this.$emit('refresh')
                    })
            } else {
                return false
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
